/* Canonical merchant chrome; native Motion owns cart/search/drawer behavior. */
(function () {
  'use strict';
  function init(root) {
    root.querySelectorAll('.glice-shop-chrome .nav-dropdown').forEach(function (dropdown) {
      if (dropdown.dataset.gliceBound) return;
      dropdown.dataset.gliceBound = '1';
      var toggle = dropdown.querySelector(':scope > a');
      if (!toggle) return;
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      function open(value) {
        dropdown.classList.toggle('open', value);
        toggle.setAttribute('aria-expanded', value ? 'true' : 'false');
        panel.inert = !value;
      }
      open(false);
      toggle.addEventListener('click', function (event) { event.preventDefault(); open(!dropdown.classList.contains('open')); });
      dropdown.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { open(false); toggle.focus(); }
        if (event.key === 'ArrowDown' && event.target === toggle) { event.preventDefault(); open(true); panel.querySelector('a,button')?.focus(); }
      });
      dropdown.addEventListener('focusout', function () { setTimeout(function () { if (!dropdown.contains(document.activeElement)) open(false); }, 0); });
      document.addEventListener('click', function (event) { if (!dropdown.contains(event.target)) open(false); });
    });
    root.querySelectorAll('.glice-shop-mobile .mobile-products-toggle').forEach(function (toggle) {
      if (toggle.dataset.gliceBound) return;
      toggle.dataset.gliceBound = '1';
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      function open(value) { panel.classList.toggle('open', value); toggle.setAttribute('aria-expanded', value ? 'true' : 'false'); panel.inert = !value; }
      open(false);
      toggle.addEventListener('click', function () { open(toggle.getAttribute('aria-expanded') !== 'true'); });
    });
    root.querySelectorAll('.glice-shop-controls #activeCurrency,.glice-shop-controls #activeLanguage').forEach(function (toggle) {
      if (toggle.dataset.gliceBound) return;
      toggle.dataset.gliceBound = '1';
      var panel = toggle.nextElementSibling;
      if (!panel) return;
      // Existing EU Motion script retains its click handler. Observe its state.
      new MutationObserver(function () { toggle.setAttribute('aria-expanded', panel.classList.contains('open') ? 'true' : 'false'); }).observe(panel, {attributes: true, attributeFilter: ['class']});
      toggle.addEventListener('keydown', function (event) { if (event.key === 'Escape') { panel.classList.remove('open'); toggle.focus(); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
